import { render, staticRenderFns } from "./FileDeleteDialog.vue?vue&type=template&id=0c628f0a&scoped=true&lang=html"
import script from "./FileDeleteDialog.vue?vue&type=script&lang=js"
export * from "./FileDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c628f0a",
  null
  
)

export default component.exports